import { MessageBox } from "element-ui";
import { Message } from "element-ui";
import { Notification } from "element-ui";

export default class Notice {
  //message表示通知的正文，type定义不同的状态，success, warning, info, error，showClose表示能否被人工关闭
  //Object.assign() 方法用于将所有可枚举属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
  message(message, type = "success", showClose = true, options = {}) {
    let messageOption = Object.assign(
      {
        message,
        type,
        showClose
      },
      options
    );
    Message(messageOption);
  }

  notification(message, type = "success", title, options = {}) {
    let notificationOption = Object.assign(
      {
        message,
        type,
        title
      },
      options
    );
    Notification(notificationOption);
  }

  messageBox(
    method,
    message,
    title,
    type,
    confirmButtonText = "Yes",
    cancelButtonText = "No",
    options = {}
  ) {
    let messageBoxOption = Object.assign(
      {
        confirmButtonText,
        cancelButtonText,
        type
      },
      options
    );
    return function(successCall, errorCall = () => {}) {
      MessageBox[method](message, title, messageBoxOption)
        .then(successCall)
        .catch(errorCall);
    };
  }
}
